// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__JpHKF","LandingSection":"Landing_LandingSection__fwCIb","Content":"Landing_Content__fDK9G","Wave":"Landing_Wave__8uIvZ"};